<ng-scrollbar track="horizontal" [sensorThrottleTime]="1">
  <div class="filters">
    @for (filter of filters$ | async; track filter) {
    <mat-form-field class="light" [class.not-default-value]="filter.formControl.value[0] !== filter.defaultValue">
      <mat-label>{{ filter.label }}</mat-label>
      <mat-select [formControl]="filter.formControl" (selectionChange)="updateFilter(filter)" multiple>
        <mat-option>
          <ngx-mat-select-search
            (keydown.enter)="selectFirstSearchResult(filter)"
            [formControl]="filter.searchFormControl"
            [placeholderLabel]="filter.label"
          >
          </ngx-mat-select-search>
        </mat-option>
        @for (optionGr of filter.filteredOptions | async; track optionGr; let grpLast = $last) { @for (option of optionGr.options; track
        option) {
        <mat-option [value]="option.value" [disabled]="option.value === filter.disabledOption && isDisabled(filter)">
          {{ option.label }}
        </mat-option>
        } @if (!grpLast) {
        <mat-divider></mat-divider>
        } }
      </mat-select>
    </mat-form-field>
    }
    <div>
      <button class="mat-elevation-z0 flat-mini-fab" mat-mini-fab (click)="resetFilters()">
        <mat-icon>replay</mat-icon>
      </button>
    </div>
  </div>
</ng-scrollbar>
